module.exports = __webpack_public_path__ + "img/warning.9411eb88.svg";